import React from "react";
import Hero from "../../shared_lib/custom/hero/Hero";
import hero from "../../assets/img/hero/hero.png";
import HeadingH3 from "../../shared_lib/custom/headings/headingH3/HeadingH3";
import Caption from "../../shared_lib/custom/headings/caption/Caption";

const HeroContent = () => {
  return (
    <Hero
      bgImage={hero}
      box={
        <div>
          <HeadingH3>Linde Digital Suite</HeadingH3>
         {/* <Caption>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab aliquam
            amet asperiores debitis dolore, eaque enim hic illo illum labore
            laudantium nulla placeat.
          </Caption>*/}
        </div>
      }
    />
  );
};

export default HeroContent;
